'use strict';

angular.module('app.locked', [])
.config([
  '$stateProvider', function($stateProvider) {
    return $stateProvider.state('app.locked', {
      templateUrl: 'components/locked/lockedView.html',

      controller: [ '$stateParams', '$scope', '$window',
          function($stateParams, $scope, $window) {
        $scope.stateParams = $stateParams;
        $scope.openUrl = function(url) {$window.open(url);}
      },
    ],

      title: 'Locked Out',
      noSidebar: true,
      noTopControls: true,
      params : {obj: null}
    });
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/locked/locked.js